// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'core-js/stable'
import 'regenerator-runtime/runtime'

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")


// For cocoon
require("jquery")
require("@nathanvda/cocoon")

require("popper.js")
require("bootstrap")

import "../stylesheets/application.scss"

// import 'bootstrap'

// require.context('../images', true)


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

document.addEventListener("turbolinks:load", () => {
    function toggleSidebar() {
        $(".sidebar").toggleClass("toggled");
        ($(".sidebar").hasClass("toggled")) ?
            $('.nav-item.active .collapse').removeClass('show') :
            $('.nav-item.active .collapse').addClass('show');
    }

    let sidebarToggle = document.getElementById('sidebarToggle');
    let sidebarToggleTop = document.getElementById('sidebarToggleTop');

    $(document).ready(function () {
        $('.datepicker').datepicker({
            format: 'dd/mm/yyyy',
            todayBtn: "linked",
            todayHighlight: true,
            autoclose: true
        });

        // Set responded to true when feedback responded button was clicked
        $('.respond-btn').on('click', function() {
            let form_query_form = $(this).parents('form.edit_form_query');
            $(form_query_form).find('input[name="form_query[responded]"]').val(true);
        })

        // For shrinking the sidebar
        // sidebarToggle.addEventListener('click', function () {
        //     toggleSidebar()
        // });
        // sidebarToggleTop.addEventListener('click', function () {
        //     toggleSidebar()
        // });

        // Hide search query modal comments after closing
        $('.resolved-btn').on('click', function () {
            let form_query_form = $(this).parents('form.edit_form_query');
            $(form_query_form).find('input[name="form_query[resolved]"]').val(true);
        })

        $('.unresolved-btn').on('click', function () {
            let form_query_form = $(this).parents('form.edit_form_query');
            $(form_query_form).find('input[name="form_query[resolved]"]').val(false);
        })

        $('.respond-btn').on('click', function () {
            let search_query_form = $(this).parents('form.edit_search_query');
            $(search_query_form).find('input[name="search_query[responded]"]').val(true);
        })

        // End Hide search query modal comments after closing

        $('#unscheduled-assessment-relevant-fields').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
            insertedItem.find('div.subject_unscheduled_assessment_unscheduled_assessments_test_performed_reason_specify').hide();
            $('.datepicker').datepicker({
                format: 'dd/mm/yyyy',
                todayBtn: "linked",
                todayHighlight: true,
                autoclose: true
            });
        });
        
        $('#conc-meds-relevant-fields').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
            insertedItem.children('.subject_conc_med_conc_meds_ae_number').hide();
            insertedItem.children('.subject_conc_med_conc_meds_stop_date').hide();
            insertedItem.find('div.subject_conc_med_conc_meds_unit_specify').hide();
            insertedItem.find('div.subject_conc_med_conc_meds_route_specify').hide();
            $('.datepicker').datepicker({
                format: 'dd/mm/yyyy',
                todayBtn: "linked",
                todayHighlight: true,
                autoclose: true
            });
        });

        $('#adverse-event-relevant-fields').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
            insertedItem.children('.subject_adverse_event_adverse_events_report_sponsor_date').hide();
            insertedItem.children('.subject_adverse_event_adverse_events_event_end_date').hide();
            insertedItem.children('.subject_adverse_event_adverse_events_event_death').hide();
            insertedItem.children('.subject_adverse_event_adverse_events_death_date').hide();

            $('.datepicker').datepicker({
                format: 'dd/mm/yyyy',
                todayBtn: "linked",
                todayHighlight: true,
                autoclose: true
            });
        });

        $('#histologies_table').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
            insertedItem.find('.subject_histology_histologies_tumour_location_specify').hide();
            insertedItem.find('.subject_histology_histologies_histology_reason_specify').hide();
            insertedItem.find('.subject_histology_histologies_histology_type_specify').hide();
            insertedItem.find('.subject_histology_histologies_histology_location_specify').hide();

            $('.datepicker').datepicker({
                format: 'dd/mm/yyyy',
                todayBtn: "linked",
                todayHighlight: true,
                autoclose: true
            });
        });


        $('#tumour_details_table').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
            insertedItem.find('.subject_tumour_detail_tumour_details_tumour_location_specify').hide();
        });

        $('#tumour_treatments_table').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
            insertedItem.find('.subject_tumour_treatment_tumour_treatments_tumour_location_specify').hide();
        });


        // Save complete/incomplete
        $('input.complete-btn[type="submit"]').click(function (event) {
            event.preventDefault();
            $('input.completed-input').val(true);
            $(this).parents('form').submit();
        })
        $('input.incomplete-btn[type="submit"]').click(function (event) {
            event.preventDefault();
            $('input.completed-input').val(false);
            $(this).parents('form').submit();
        })


        // End save complete/incomplete


        // Disabled HTML5 required check on ransack search form
        let search_query_form = $('form.search-form');
        $(search_query_form).find('select').prop('required', null);
        $(search_query_form).find('input').prop('required', null);
        // End Disabled HTML5 required check on ransack search form



        // Input format check when type = number

        // Set tooltips auto hide
        $(document).on('shown.bs.tooltip', function (e) {
            setTimeout(function () {
                $(e.target).tooltip('hide');
            }, 1500);
        });

        // Check input format when unfocus if input type is number
        $('#wrapper').on("focusout", "input[type='number']", function (event) {
            checkNumberInputFormat(this, event);
        });

        function checkNumberInputFormat(input, event) {
            let numbers_format = new RegExp('^[+-]?[0-9]+\.?[0-9]*$');
            let value = $(input).val();
            if (numbers_format.test(value)) {
                $(input).tooltip('hide');
            } else {
                $(input).tooltip({
                    title: 'Numbers only',
                    placement: 'top',
                    trigger: 'manual'
                }).tooltip('show');
            }
        }
        // End Input format check when type = number
    });
});